<template>
  <!-- <div class="row"> -->
  <div class="col-md-12">
    <div class="assign-item row">
      <!-- <div class="row"> -->
      <component
        :is="'a'"
        :href="editURL"
        :target="'_blank'"
        class="clickable d-none d-sm-flex col-2 col-md-1 align-items-center"
      >
        <div class="avatar d-flex align-items-center">
          <template v-if="itemType == 'default'">
            <svg
              width="58"
              height="58"
              viewBox="0 0 58 58"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 21.5352L29 14.082L44 21.5351V22.5195L29 29.9726L14 22.543V21.5352Z"
                fill="#FFE097"
              />
              <path
                d="M14 21.5352L29 28.9883L44 21.5352V36.4648L28.9531 43.9179L14 36.4649V21.5352Z"
                fill="#EED089"
              />
              <path
                d="M29 43.8946V28.9884L14.0937 21.582H14V36.4648L28.9531 43.9179L29 43.8946Z"
                fill="#D0B46F"
              />
              <path
                d="M20.1172 18.5116L35.0937 25.9648L38.1406 24.4648L23.1172 17.0117L20.1172 18.5116Z"
                fill="#FFBE21"
              />
              <path
                d="M35.0938 25.9648L38.1406 24.4648V29.1523L37.3203 29.0117L36.4531 30.0664L35.0938 29.9727C35.0938 29.9726 35.0938 25.9648 35.0938 25.9648Z"
                fill="#EEAF16"
              />
              <path
                d="M25.9063 34.9413L20.8438 32.4101C20.5625 32.2695 20.3281 32.4335 20.3281 32.7851V36.1836C20.3281 36.5351 20.5625 36.9335 20.8438 37.0742L25.9297 39.6054C26.211 39.746 26.4454 39.5819 26.4454 39.2304V35.8085C26.4219 35.4569 26.1875 35.082 25.9063 34.9413ZM24.7578 37.7304L21.5234 36.1132C21.3828 36.0429 21.2656 35.832 21.2656 35.6445C21.2656 35.4569 21.3828 35.3632 21.5234 35.4335L24.7578 37.0507C24.8984 37.121 25.0156 37.3319 25.0156 37.5194C25.0156 37.7069 24.8984 37.8007 24.7578 37.7304ZM25.2266 36.5585L21.5234 34.6834C21.3828 34.6131 21.2656 34.4022 21.2656 34.2147C21.2656 34.0272 21.3828 33.9335 21.5234 34.0037L25.2266 35.8787C25.3672 35.9491 25.4844 36.16 25.4844 36.3475C25.4844 36.5585 25.3672 36.6287 25.2266 36.5585Z"
                fill="#F2F2F2"
              />
            </svg>
          </template>
          <img v-else :src="avatar" alt />
        </div>
      </component>
      <component
        :is="'a'"
        :href="editURL"
        :target="'_blank'"
        class="clickable col-5 col-md-6 d-flex align-items-center"
      >
        <div class="ellipsis-text title">
          <p class="typo-title1 text-secondary4">{{ title }}</p>
        </div>
      </component>
      <div class="col-4 col-md-4 d-flex align-items-center">
        <div class="select-options">
          <select name id v-show="false" v-model="pageActive.title">
            <option
              v-for="(page, index) in filterItems"
              :value="page.id"
              :key="index"
            >{{ page.title }}</option>
          </select>
          <div class="fake-select-option">
            <Dropdown ref="dropdown" class bclass="select" lclass>
              <template v-slot:button>
                <p class="ellipsis-text typo_body2 text-left">{{ pageActive.title }}</p>
              </template>
              <div
                class="gp_dropdown-item text-black1"
                v-for="(page, index) in filterItems"
                :key="index"
                @click="itemClick(page)"
                :data-page-id="page.id"
              >
                <p class="typo_body2 text-left">{{ page.title }}</p>
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
      <div class="col-1 col-md-1 d-flex align-items-center">
        <template v-if="itemType !== 'default'">
          <div class="option" @click="openModal">
            <i class="cancel-button icon icon-cancel typo-h4"></i>
          </div>
        </template>
      </div>
      <!-- </div> -->
    </div>
    <!-- Modal Delete -->
    <Modal :hideExit="true" @cancel="closeModal" v-if="modalActive">
      <template #header>
        <p class="typo-title1">{{ $t("page.assignment.deleteAssign") }}</p>
      </template>
      <template #default>
        <template>
          <p class="typo-body2 text-grey2">
            {{ $t("page.areYouSure") }}
            {{ $t("page.assignment.deleteSetting") }}
          </p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group justify-content-between">
          <button class="btn btn-block btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>

          <template>
            <button
              class="btn btn-block btn-danger ml-2"
              @click="deleteAssign"
            >{{ $t("generals.delete") }}</button>
          </template>
        </div>
      </template>
    </Modal>

    <!-- Modal Make Default -->
    <Modal :hideExit="true" @cancel="closeModalMakeDefault" v-if="modalMakeDefaultActive">
      <template #header>
        <p class="typo-title1">{{ $t("page.assignment.mkDefaultTmp") }}</p>
      </template>
      <template #default>
        <template>
          <p class="typo-body2 text-grey2">
            {{ $t("page.areYouSure") }}
            <span class="text-primary" v-if="!isAssignDefault()">
              {{
              $t("page.assignment.asDefault")
              }}
            </span>
            <span v-else class="text-primary">
              {{
              $t("page.assignment.returnOriginal", {
              type: $tc(`page.${type}`, 1)
              })
              }}
            </span>
          </p>
          <p class="typo-body2 text-grey2">
            {{
            $t("page.assignment.explain", { type: $tc(`page.${pType}`, 2) })
            }}.
          </p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group justify-content-between">
          <button
            class="btn btn-block btn-outline"
            @click="closeModalMakeDefault"
          >{{ $t("generals.cancel") }}</button>

          <template>
            <button
              class="btn btn-block btn-primary ml-2"
              @click="confirmMakeDefault"
            >{{ $t("generals.apply") }}</button>
          </template>
        </div>
      </template>
    </Modal>

    <!-- Modal Assign -->
    <Modal :hideExit="true" @cancel="closeModalAssign" v-if="modalAssignActive">
      <template #header>
        <p class="typo-title1">{{ $t("page.assignment.chngTmp") }}</p>
      </template>
      <template #default>
        <template>
          <p class="typo-body2 text-grey2">
            {{ $t("page.areYouSure") }}
            <span class="text-primary">
              {{
              $t("page.assignment.change4this", {
              type: $tc(`page.${pType}`, ``)
              })
              }}
            </span>
          </p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group justify-content-between">
          <button
            class="btn btn-block btn-outline"
            @click="closeModalAssign"
          >{{ $t("generals.cancel") }}</button>

          <template>
            <button
              class="btn btn-block btn-primary ml-2"
              @click="confirmAssign"
            >{{ $t("generals.apply") }}</button>
          </template>
        </div>
      </template>
    </Modal>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "AssignmentItem",
  props: {
    assign: Object,
    pages: Array,
    type: String,
    itemType: String
  },
  data() {
    return {
      pageActive: {},
      pageActiveBak: {},
      modalActive: false,
      modalAssignActive: false,
      modalMakeDefaultActive: false,
      items: []
    };
  },
  computed: {
    ...mapGetters("page", {}),
    ...mapState("page", {
      pageList: "pages",
      assigmentList: "assignments"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    editURL() {
      let urlType = this.type == "productpages" ? "products" : "collections";
      return `https://${this.shopInfo.shopifyDomain}/${urlType}/${this.assign.handle}`;
    },
    pType() {
      if (!this.type) return "pages";
      let type = this.type.split("pages")[0];
      return type;
    },
    inheritObj() {
      let type = this.$tc(`page.${this.pType}`, 2);

      return {
        id: "inherit",
        title: this.$t("page.assignment.inherit", { type: type })
      };
    },
    avatar() {
      return this.assign &&
        this.assign.hasOwnProperty("image") &&
        this.assign.image.hasOwnProperty("src")
        ? this.assign.image.src
        : "https://ucarecdn.com/c46e919d-2c25-4095-918e-66323b559d41/-/format/auto/-/preview/3000x3000/-/quality/lighter/";
    },
    currentPageType() {
      return this.pageList[this.type];
    },
    currentPageTypeList() {
      return this.currentPageType.list;
    },
    currentAssignement() {
      return this.assigmentList[this.type];
    },
    currentAssignementList() {
      return this.currentAssignement.list;
    },
    title() {
      return this.assign && this.assign.hasOwnProperty("title")
        ? this.assign.title
        : "";
    },
    filterItems() {
      var newTemplate = [];
      for (var i = 0; i < this.items.length; i++) {
        var template = this.items[i];
        if (template.title != "Theme Product Template") {
          newTemplate.push(template);
        }
      }
      if (this.itemType == "default") {
        return this.items;
      }
      return newTemplate;
    }
  },
  watch: {
    assign: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.template_suffix != oldVal.template) {
          this.pageActive = this.findTemplateAssign(newVal.template_suffix);
        }
      }
    },
    currentPageTypeList: {
      deep: true,
      handler() {}
    },
    currentAssignementList: {
      deep: true,
      handler() {
        this.modalAssignActive = false;
        this.modalActive = false;
      }
    }
  },
  created() {
    // Magic trick from Felixx
    this.items = JSON.parse(JSON.stringify(this.pages));

    if (this.itemType != "default") {
      this.appendInherit();
    }

    if (this.type) {
      if (this.itemType == "default") {
        this.pageActive = this.getAssignedPublished();
      } else {
        if (this.assign) {
          this.pageActive = this.findTemplateAssign(
            this.assign.template_suffix
          );
        }
      }
    }
  },
  methods: {
    ...mapActions("page", {
      assignTemplate: "assignTemplate",
      makeDefault: "makeDefault"
    }),
    itemClick(pageSelected) {
      this.pageActiveBak = this.pageActive;
      this.pageActive = pageSelected;
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
      if (this.itemType == "default") {
        this.openModalMakeDefault();
      } else {
        this.openModalAssign();
      }
    },
    getAssignedPublished() {
      return this.items.find(e => e.published == true);
    },
    isAssignDefault() {
      let _default = [
        "Theme Index Template",
        "Your first Homepage",
        "Theme Product Template",
        "Theme Collection Template"
      ];
      if (_default.includes(this.pageActive.title)) {
        return true;
      }
      return false;
    },
    findTemplateAssign(template_suffix) {
      if (
        template_suffix &&
        template_suffix.trim() != "" &&
        template_suffix.indexOf("gem-") > -1
      ) {
        var regex = /[0-9]+/;
        var str = template_suffix;
        if (str.match(regex)[0]) {
          var idTemplate = parseInt(str.match(regex)[0]);
          for (var i = 0; i < this.items.length; i++) {
            var template = this.items[i];
            if (parseInt(template.id) == idTemplate) {
              return template;
            }
          }
        }
      } //else {
      return this.inheritObj;
    },
    openModal() {
      this.modalActive = true;
    },
    closeModal() {
      this.modalActive = false;
    },

    openModalAssign() {
      this.modalAssignActive = true;
    },
    closeModalAssign() {
      this.modalAssignActive = false;
      this.pageActive = this.pageActiveBak;
    },
    openModalMakeDefault() {
      this.modalMakeDefaultActive = true;
    },
    closeModalMakeDefault() {
      this.modalMakeDefaultActive = false;
      this.pageActive = this.pageActiveBak;
    },
    deleteAssign() {
      this.assignTemplate({
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        templateId: 0,
        assignId: this.assign.id
      });
      this.modalActive = false;
    },
    appendInherit() {
      let found = this.items.find(e => e.id == "inherit");

      if (!found) {
        this.items.unshift(this.inheritObj);
      }
    },
    confirmAssign() {
      this.assignTemplate({
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        templateId: this.pageActive.id,
        assignId: this.assign.id
      });
      this.modalAssignActive = false;
    },
    confirmMakeDefault() {
      this.makeDefault({
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        page: this.pageActive
      });
      this.modalMakeDefaultActive = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.assign-list {
  .assign-item {
    @include trans-all;
    background: $neutral5;
    border-radius: 10px;
    margin-bottom: 10px;
    min-height: 90px;
    justify-content: center;

    &:hover {
      @include trans-all;
      box-shadow: 0px 7px 64px rgba(0, 24, 46, 0.15);
    }
    .avatar {
      width: 60px;
      height: 60px;
      img {
        width: 100%;
        height: auto;
      }
      svg {
        max-width: 100%;
      }
    }
    .select-options {
      width: 100%;
      .fake-select-option {
        ::v-deep .select {
          width: 100%;
          font-weight: inherit;
          flex-direction: row;
          justify-content: space-between;
          background: $neutral5;
          border-radius: 5px;
          border: 0.5px solid $grey3;
        }
        ::v-deep .gp_dropdown_list {
          max-height: 30vh;
          overflow: auto;
        }
      }
    }
    .option {
      margin: auto;
      cursor: pointer;
      .cancel-button {
        padding: 10px;
        border-radius: 50%;
        @include trans-all;
        &:hover {
          background: $grey4;
          color: $cPrimary;
        }
      }
    }
  }
}

.ellipsis-text {
  max-width: 100%;
  word-break: unset;
  display: -webkit-box;
  max-height: 3.2rem;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
}
</style>
